import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';

import { actionSetLaborTickets } from 'lib/actions';
import { GET_CURRENT_MACHINE_LABOR_TICKET } from 'lib/api/queries';
import { getMachine } from 'lib/selectors/getMachine';

const useResyncMachineLaborTickets = () => {
  const dispatch = useDispatch();
  const machineRef = useSelector(getMachine)?.machineRef;
  const [requestCurrentMachineLaborTicket] = useLazyQuery(
    GET_CURRENT_MACHINE_LABOR_TICKET,
    {
      fetchPolicy: 'network-only',
    }
  );

  return useCallback(async () => {
    if (!machineRef) {
      return [];
    }

    const { data } = await requestCurrentMachineLaborTicket({
      variables: {
        where: {
          resource: { machineRef: { _eq: machineRef } },
        },
      },
    });
    const laborTickets = data?.erpLaborTickets || [];
    dispatch(actionSetLaborTickets(laborTickets));

    return laborTickets;
  }, [dispatch, machineRef, requestCurrentMachineLaborTicket]);
};

export default useResyncMachineLaborTickets;
